var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { autoinject, transient } from "aurelia-dependency-injection";
import { WorkflowConfigurationService } from "../../../../services/workflow/workflow-configuration-service";
import { computedFrom } from "aurelia-framework";
import { UnitOfWorkObserver } from "../../../../utilities/unit-of-work-observer";
import { BindingEngine } from "aurelia-framework";
import { Guid } from "../../../../utilities/guid";
import { ArrayUtils } from "../../../../utilities/arrays";
import { NotificationClientService, NotificationType } from "../../../../services/basics/notification-client.service";
import { DialogClientService } from "../../../../services/basics/dialog-client.service";
import { DialogServiceConstants } from "../../../../constants/basics/dialog.constants";
import * as Enumerable from "linq";
import { UserClientService } from "../../../../services/authentication/user-client.service";
import { NetworkStructure, NetworkNode, NetworkLink } from "../../../components/network/network-structure";
import { AllEntityTypeConfigurationConstants, EntityTypes } from "../../../../models/basics/basics.models";
import { Messages } from "../../../../configuration/event-messages.constants";
import { EventAggregator } from "aurelia-event-aggregator";
import { CloneUtility } from "../../../../utilities/clone";
import * as vis from "vis";
var WorkflowConfigurationViewModel = /** @class */ (function () {
    function WorkflowConfigurationViewModel(workflowConfigurationService, notificationClientService, dialogClientService, userClientService, eventAggregator, bindingEngine) {
        var _this = this;
        this.workflowConfigurationService = workflowConfigurationService;
        this.notificationClientService = notificationClientService;
        this.dialogClientService = dialogClientService;
        this.userClientService = userClientService;
        this.eventAggregator = eventAggregator;
        this.bindingEngine = bindingEngine;
        this._networkStructure = new NetworkStructure();
        this.workflowConfigurations = [];
        this.workflowActivitySignatures = [];
        this.entityTypes = [];
        this.pathResults = [];
        this.onNewLinkAdded = function (link) {
            _this._edges.add([_this.getVisEdge(link)]);
        };
        this.onNodesRemoved = function (nodes) {
            _this._nodes.remove(nodes.map(function (node) { return node.id; }));
        };
        this.onNewNodeAdded = function (node) {
            _this._nodes.add([_this.getVisNode(node)]);
        };
        this.onNodeSelected = function (values) {
            var nodeSelectedId = values.nodes[0];
            if (_this.selectedNode && _this.selectedNode.id != nodeSelectedId) {
                if (_this.activityConfigComposer && _this.activityConfigComposer["currentViewModel"]) {
                    var configurationVM = _this.activityConfigComposer["currentViewModel"];
                    configurationVM.setMeta().then(function () {
                        _this.selectedNode = null;
                    });
                }
                else {
                    _this.selectedNode = null;
                }
            }
            if (nodeSelectedId && (!_this.selectedNode || _this.selectedNode.id != nodeSelectedId)) {
                if (_this.activityConfigComposer && _this.activityConfigComposer["currentViewModel"]) {
                    var configurationVM = _this.activityConfigComposer["currentViewModel"];
                    configurationVM.setMeta().then(function () {
                        _this.selectedNode = _this._networkStructure.findNodeById(nodeSelectedId);
                    });
                }
                else {
                    _this.selectedNode = _this._networkStructure.findNodeById(nodeSelectedId);
                }
            }
        };
        this.onNodeDeselected = function () {
            if (_this.activityConfigComposer && _this.activityConfigComposer["currentViewModel"]) {
                var configurationVM = _this.activityConfigComposer["currentViewModel"];
                configurationVM.setMeta().then(function () {
                    _this.selectedNode = null;
                });
            }
            else {
                _this.selectedNode = null;
            }
        };
        this.changeCursorToPointer = function () {
            _this.networkCanvas.style.cursor = 'pointer';
        };
        this.changeCursorToOpenHand = function () {
            _this.networkCanvas.style.cursor = '-webkit-grab';
        };
        this.changeCursorToDragging = function () {
            _this.networkCanvas.style.cursor = '-webkit-grabbing';
        };
        this.delete = function (workflowConfigurationId) {
            return new Promise(function (resolve, reject) {
                _this.workflowConfigurationService.deleteWorkflowConfiguration(workflowConfigurationId).then(function (x) {
                    var index = ArrayUtils.findIndex(_this.workflowConfigurations, function (x) { return x.workflowConfigurationId == workflowConfigurationId; });
                    if (index > -1) {
                        _this.workflowConfigurations.splice(index, 1);
                    }
                    _this.notificationClientService.show("Deleted", "Configuration deleted successfully", NotificationType.Success);
                    _this.dialogClientService.hide();
                    resolve();
                }).catch(function (ex) {
                    _this.notificationClientService.show("Deleted", "Failed to delete configuration", NotificationType.Error);
                    _this.dialogClientService.hide();
                    reject();
                });
            });
        };
        this.workflowConfigurationService.getEntityTypesForWorkflow().then(function (x) {
            _this.entityTypes = x.entityTypes;
            _this.branchId = _this.userClientService.currentUser.branchId;
        });
    }
    Object.defineProperty(WorkflowConfigurationViewModel.prototype, "selectedNode", {
        get: function () {
            return this._selectedNode;
        },
        set: function (value) {
            var _this = this;
            this._selectedNode = value;
            setTimeout(function () {
                if (_this._network) {
                    _this._network.setSize(_this.divNetwork.offsetWidth, _this.divNetwork.offsetHeight);
                }
            });
        },
        enumerable: false,
        configurable: true
    });
    ;
    Object.defineProperty(WorkflowConfigurationViewModel.prototype, "branchId", {
        get: function () {
            return this._branchId;
        },
        set: function (value) {
            this._branchId = value;
            this.getWorkflowConfigurations();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(WorkflowConfigurationViewModel.prototype, "entityTypeUri", {
        get: function () {
            var _this = this;
            return AllEntityTypeConfigurationConstants.filter(function (x) { return x.entityType == _this._entityType; })[0].uri;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(WorkflowConfigurationViewModel.prototype, "entityType", {
        get: function () {
            return this._entityType;
        },
        set: function (value) {
            this._entityType = value;
            this.getWorkflowConfigurations();
        },
        enumerable: false,
        configurable: true
    });
    WorkflowConfigurationViewModel.prototype.getWorkflowConfigurations = function () {
        var _this = this;
        this.selectedItem = null;
        if (this.entityType && this.branchId) {
            this.workflowConfigurationService.getWorkflowConfigurations(this.entityType, this.branchId).then(function (x) {
                _this.workflowConfigurations = x.configurations;
                _this.pathResults = x.pathResults;
                _this.workflowActivitySignatures = x.workflowActivitySignatures;
            });
        }
    };
    Object.defineProperty(WorkflowConfigurationViewModel.prototype, "selectedItem", {
        get: function () {
            return this._selectedItem;
        },
        set: function (value) {
            var _this = this;
            if (value && !('name' in value)) {
                return;
            }
            //Unselect node if different configuration is selected
            if (!value || (this._selectedItem && value.workflowConfigurationId != this._selectedItem.workflowConfigurationId)) {
                this.selectedNode = null;
            }
            this._selectedItem = value;
            // destroy previous network
            if (this._network) {
                this._network.off('selectNode', this.onNodeSelected);
                this._network.off('deselectNode', this.onNodeDeselected);
                this._network.destroy();
                this._network = null;
            }
            // destroy previous unit of work
            if (this.uow) {
                this.uow.dispose();
                this.uow = null;
            }
            if (value) {
                setTimeout(function () {
                    _this._networkStructure = _this.buildNetworkStructure();
                    _this._networkStructure.subscribeOnNodeAdded(_this.onNewNodeAdded);
                    _this._networkStructure.subscribeOnNodesRemoved(_this.onNodesRemoved);
                    _this._networkStructure.subscribeOnLinkAdded(_this.onNewLinkAdded);
                    _this.uow = UnitOfWorkObserver.getTrackingInstance(_this.bindingEngine, _this.selectedItem, []);
                    if (!_this.selectedItem.workflowConfigurationId) {
                        _this.uow.addChange(function (x) { return x.entityTypeId; }, _this._entityType, 0);
                        _this.uow.addChange(function (x) { return x.isActive; }, true, false);
                        _this.uow.addChange(function (x) { return x.isSelectable; }, true, false);
                        _this.uow.addChange(function (x) { return x.guid; }, Guid.generateGuid(), null);
                        _this.uow.addChange(function (x) { return x.branchId; }, _this.branchId, null);
                    }
                    setTimeout(function () {
                        _this.createNetwork();
                    }, 100);
                });
            }
        },
        enumerable: false,
        configurable: true
    });
    WorkflowConfigurationViewModel.prototype.buildHierarchy = function (arry) {
        var roots = [], children = {};
        // find the top level nodes and hash the children based on parent
        for (var i = 0, len = arry.length; i < len; ++i) {
            var item = arry[i], p = item.parentActivityGuid, target = !p ? roots : (children[p] || (children[p] = []));
            target.push({ value: item });
        }
        var level = 0;
        // function to recursively build the tree
        var findChildren = function (parent, level) {
            parent.level = level;
            if (children[parent.value.guid]) {
                parent.children = children[parent.value.guid] ? children[parent.value.guid] : [];
                for (var i = 0, len = parent.children.length; i < len; ++i) {
                    findChildren(parent.children[i], level + 1);
                }
            }
        };
        // enumerate through to handle the case where there are multiple roots
        for (var i = 0, len = roots.length; i < len; ++i) {
            findChildren(roots[i], level);
        }
        return roots[0];
    };
    WorkflowConfigurationViewModel.prototype.buildNetworkStructure = function () {
        var _this = this;
        var config = this._selectedItem;
        var networkStructure = new NetworkStructure();
        var activities = Enumerable.from(config.workflowActivities).orderBy(function (x) { return x.workflowActivityId; }).toArray();
        activities.forEach(function (activity) {
            _this.createNetworkLink(networkStructure, activity.parentActivityGuid, activity.guid, activity.pathResult);
        });
        var tree = this.buildHierarchy(activities);
        if (tree) {
            this.processTree(networkStructure, tree);
        }
        else {
            this.attachAddNewActivityNode(networkStructure, null, null);
        }
        return networkStructure;
    };
    WorkflowConfigurationViewModel.prototype.processTree = function (networkStructure, tree) {
        var _this = this;
        var activity = tree.value;
        var level = tree.level;
        var childNode = new NetworkNode();
        var signature = this.workflowActivitySignatures.filter(function (x) { return x.internalName == activity.internalName; })[0];
        childNode.id = activity.guid;
        childNode.data = { activity: activity };
        childNode.level = level;
        childNode.text = activity.name;
        childNode.shape = signature.shape;
        childNode.color = signature.background;
        childNode.fontColor = "black";
        networkStructure.addNode(childNode);
        if (!tree.children) {
            tree.children = [];
        }
        if (signature.pathResults && signature.pathResults.length > 0) {
            var activities_1 = [];
            tree.children.forEach(function (child) {
                var activity = child.value;
                activities_1.push(activity);
                _this.processTree(networkStructure, child);
            });
            signature.pathResults.filter(function (x) { return activities_1.every(function (y) { return y.pathResult != x; }); }).forEach(function (path) {
                _this.attachAddNewActivityNode(networkStructure, childNode, path);
            });
        }
        else {
            if (!tree.children || tree.children.length == 0) {
                this.attachAddNewActivityNode(networkStructure, childNode, null);
            }
            else {
                tree.children.forEach(function (child) {
                    _this.processTree(networkStructure, child);
                });
            }
        }
    };
    WorkflowConfigurationViewModel.prototype.onActivityNameChanged = function () {
        var node = this._nodes.get(this.selectedNode.id);
        node.label = this.selectedNode.text = this.selectedNode.data.activity.name;
        this._nodes.update(node);
    };
    WorkflowConfigurationViewModel.prototype.onNewActivitySelected = function (activitySignature) {
        var _this = this;
        if (!this._network) {
            this.createNetwork();
        }
        var internalName = activitySignature.internalName;
        var activity = this.addNewActivity(internalName, this.selectedNode.id);
        this.selectedNode.applyDefaults();
        this.selectedNode.id = activity.guid;
        this.selectedNode.data = { activity: activity };
        this.selectedNode.level = this.selectedNode.level;
        this.selectedNode.text = activity.name = "Activity" + "#" + this.selectedItem.workflowActivities.length;
        this.selectedNode.color = activitySignature.background;
        this.selectedNode.fontColor = "white";
        this.selectedNode.shape = activitySignature.shape;
        var sourceNode = this._networkStructure.getSourceNodeFromTargetNode(this.selectedNode.id);
        if (sourceNode) {
            var linkForPath_1 = this._networkStructure.getLink(sourceNode.id, this.selectedNode.id);
            //this._networkStructure.removeNode(this.selectedNode.id, true);
            var sourceActivity_1 = this.selectedItem.workflowActivities.filter(function (z) { return z.guid == sourceNode.id; })[0];
            if (sourceActivity_1) {
                var sourceActivitySignature = this.workflowActivitySignatures.filter(function (x) { return x.internalName == sourceActivity_1.internalName; })[0];
                activity.pathResult = sourceActivitySignature.pathResults.filter(function (x) { return x == linkForPath_1.data.path; })[0];
                activity.parentActivityGuid = sourceActivity_1.guid;
            }
            var linkText = activity.pathResult ? this.pathResults.filter(function (x) { return x.workflowActivityPathResultId == activity.pathResult; })[0].name : "";
            linkForPath_1.text = linkText;
            linkForPath_1.data = { path: activity.pathResult };
            //this.createNetworkLink(this._networkStructure, sourceNode.id, this.selectedNode.id, activity.pathResult);
        }
        if (activitySignature.pathResults && activitySignature.pathResults.length > 0) {
            activitySignature.pathResults.forEach(function (path) {
                _this.attachAddNewActivityNode(_this._networkStructure, _this.selectedNode, path);
            });
        }
        else {
            this.attachAddNewActivityNode(this._networkStructure, this.selectedNode, null);
        }
        this._nodes.update(this.getVisNode(this.selectedNode));
    };
    WorkflowConfigurationViewModel.prototype.attachAddNewActivityNode = function (networkStructure, node, pathNumber) {
        var newActivityNode = this.createNewActivityNode(Guid.generateGuid(), node ? (node.level + 1) : 0);
        networkStructure.addNode(newActivityNode);
        if (node) {
            this.createNetworkLink(networkStructure, node.id, newActivityNode.id, pathNumber);
        }
    };
    WorkflowConfigurationViewModel.prototype.createNetworkLink = function (networkStructure, sourceNodeId, targetNodeId, pathNumber) {
        var linkText = pathNumber ? this.pathResults.filter(function (x) { return x.workflowActivityPathResultId == pathNumber; })[0].name : "";
        var link = new NetworkLink(sourceNodeId, targetNodeId, linkText, { path: pathNumber });
        networkStructure.addLink(link);
    };
    WorkflowConfigurationViewModel.prototype.createNewActivityNode = function (id, level) {
        var childNode = new NetworkNode();
        childNode.id = id;
        childNode.data = { isNewActivity: true };
        childNode.level = level;
        childNode.text = "+";
        childNode.size = { height: 50, width: 50 };
        childNode.fontSize = 25;
        childNode.color = "orange";
        childNode.fontColor = "white";
        childNode.shape = "box";
        return childNode;
    };
    WorkflowConfigurationViewModel.prototype.createNetwork = function () {
        var _this = this;
        this._nodes = new vis.DataSet();
        // create an array with edges
        this._edges = new vis.DataSet();
        this.linkNetworkData();
        // provide the data in the vis format
        var data = {
            nodes: this._nodes,
            edges: this._edges
        };
        var options = {
            layout: {
                hierarchical: {
                    enabled: true,
                    direction: 'UD',
                    nodeSpacing: 250
                }
            },
            physics: {
                enabled: false
            },
            width: this.divNetwork.offsetWidth + "px",
            height: this.divNetwork.offsetHeight + "px",
            interaction: {
                hover: true,
                dragNodes: false,
                hoverConnectedEdges: false
            }
        };
        this._network = new vis.Network(this.divNetwork, data, options);
        this._network.on('selectNode', this.onNodeSelected);
        this._network.on('deselectNode', this.onNodeDeselected);
        this._network.on('hoverNode', this.changeCursorToPointer);
        this._network.on('blurNode', this.changeCursorToOpenHand);
        this._network.on('dragging', this.changeCursorToDragging);
        this._network.on('dragStart', this.changeCursorToDragging);
        this._network.on('dragEnd', this.changeCursorToOpenHand);
        if (this.selectedNode) {
            this._network.selectNodes([this.selectedNode.id]);
        }
        setTimeout(function () {
            if (!_this.networkCanvas) {
                _this.networkCanvas = _this.divNetwork.getElementsByTagName("canvas")[0];
            }
            _this.networkCanvas.style.cursor = '-webkit-grab';
        });
    };
    WorkflowConfigurationViewModel.prototype.linkNetworkData = function () {
        var _this = this;
        this._networkStructure.getNodes().forEach(function (node) {
            _this._nodes._addItem(_this.getVisNode(node));
        });
        this._networkStructure.getLinks().forEach(function (link) {
            _this._edges._addItem(_this.getVisEdge(link));
        });
    };
    WorkflowConfigurationViewModel.prototype.save = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var innerSaveFunc = function () {
                _this.workflowConfigurationService.saveWorkflowConfiguration({ id: _this.selectedItem.workflowConfigurationId, changes: _this.uow.getChanges() }).then(function (response) {
                    if (response.validationResult && response.validationResult.hasError) {
                        _this.showValidationErrors(response);
                    }
                    else if (response.workflowConfiguration) {
                        if (!_this.selectedItem.workflowConfigurationId) {
                            _this.workflowConfigurations.push(response.workflowConfiguration);
                        }
                        else {
                            var index = ArrayUtils.findIndex(_this.workflowConfigurations, function (y) { return y.workflowConfigurationId == response.workflowConfiguration.workflowConfigurationId; });
                            if (index > -1) {
                                _this.workflowConfigurations.splice(index, 1, response.workflowConfiguration);
                            }
                        }
                        _this.selectedItem = response.workflowConfiguration;
                        _this.notificationClientService.show("Saved", "Saved successfully", NotificationType.Success);
                    }
                    else {
                        _this.notificationClientService.show("An error occurred while saving", "", NotificationType.Error);
                    }
                    resolve();
                }).catch(reject);
            };
            if (_this.activityConfigComposer && _this.activityConfigComposer["currentViewModel"]) {
                var configurationVM = _this.activityConfigComposer["currentViewModel"];
                configurationVM.setMeta().then(function () {
                    innerSaveFunc();
                });
            }
            else {
                innerSaveFunc();
            }
        });
    };
    WorkflowConfigurationViewModel.prototype.showValidationErrors = function (response, preffix) {
        if (preffix === void 0) { preffix = null; }
        var fullError = "";
        Enumerable.from(response.validationResult.errors).distinct(function (error) { return error.message; }).forEach(function (error) {
            fullError += error.message + "<br/>";
        });
        var message = preffix
            ? (preffix + "<br/>" + fullError)
            : fullError;
        this.notificationClientService.show("Validation Error!", message, NotificationType.Error);
        this.eventAggregator.publish(Messages.onValidated, response.validationResult);
    };
    WorkflowConfigurationViewModel.prototype.removeConfig = function (config) {
        var _this = this;
        event.stopPropagation();
        this.dialogClientService.show(DialogServiceConstants.URLs.DeleteModal, { delete: function () { return _this.delete(config.workflowConfigurationId); } });
    };
    WorkflowConfigurationViewModel.prototype.cancel = function () {
        var _this = this;
        var index = this.workflowConfigurations.findIndex(function (x) { return x == _this.selectedItem; });
        if (index > -1) {
            if (this._originalSelectedItem && this._originalSelectedItem.workflowConfigurationId > 0) {
                this.workflowConfigurations.splice(index, 1, this._originalSelectedItem);
            }
            else {
                this.workflowConfigurations.splice(index, 1);
            }
        }
        this.selectedItem = null;
        if (this.uow) {
            this.uow.dispose();
            this.uow = null;
        }
    };
    WorkflowConfigurationViewModel.prototype.createNewWorkflowConfiguration = function () {
        this.selectedItem = {
            entityTypeId: 0,
            guid: null,
            isActive: false,
            isSelectable: false,
            name: '',
            workflowConfigurationId: 0,
            workflowActivities: [],
            branchId: this.branchId,
            entityType: EntityTypes.WorkflowConfiguration
        };
    };
    WorkflowConfigurationViewModel.prototype.deleteSelectedNode = function () {
        var _this = this;
        var sourceNode = this._networkStructure.getSourceNodeFromTargetNode(this.selectedNode.id);
        var path = this.selectedNode.data.activity.pathResult;
        var nodesRemoved = this._networkStructure.removeNode(this.selectedNode.id, true);
        nodesRemoved.forEach(function (nodeRemoved) {
            var index = ArrayUtils.findIndex(_this.selectedItem.workflowActivities, function (x) { return nodeRemoved.data.activity && x.guid == nodeRemoved.data.activity.guid; });
            if (index > -1) {
                _this.selectedItem.workflowActivities.splice(index, 1);
                _this.selectedNode = null;
            }
        });
        this.attachAddNewActivityNode(this._networkStructure, sourceNode, path);
    };
    WorkflowConfigurationViewModel.prototype.selectConfiguration = function (config) {
        this._originalSelectedItem = CloneUtility.cloneObject(config);
        this.selectedItem = config;
    };
    WorkflowConfigurationViewModel.prototype.addNewActivity = function (internalName, id) {
        var activity = {
            actionTakerDepartmentId: null,
            creationDate: new Date(),
            isActive: true,
            guid: id,
            isSelectable: true,
            lastModified: new Date(),
            meta: "",
            name: '',
            internalName: internalName,
            workflowConfigurationId: this.selectedItem.workflowConfigurationId,
            workflowActivityId: 0,
            parentActivityGuid: null
        };
        this.selectedItem.workflowActivities.push(activity);
        return activity;
    };
    WorkflowConfigurationViewModel.prototype.removeActivity = function (step) {
        var index = ArrayUtils.findIndex(this.selectedItem.workflowActivities, function (x) { return x == step; });
        if (index > -1) {
            this.selectedItem.workflowActivities.splice(index, 1);
        }
    };
    WorkflowConfigurationViewModel.prototype.getVisNode = function (node) {
        return {
            id: node.id,
            label: node.text,
            shape: node.shape,
            level: node.level,
            color: node.color,
            font: {
                color: node.fontColor,
                size: node.fontSize,
                face: node.fontFace,
                background: node.fontBackground
            },
            widthConstraint: {
                minimum: node.size ? node.size.width : 100,
                maximum: node.size ? node.size.width : 100
            },
            heightConstraint: {
                minimum: node.size ? node.size.height : 100,
                maximum: node.size ? node.size.height : 100
            },
            shadow: true,
            size: 50,
            image: undefined
        };
    };
    WorkflowConfigurationViewModel.prototype.getVisEdge = function (link) {
        return {
            from: link.sourceId,
            to: link.targetId,
            arrows: {
                to: { enabled: true, scaleFactor: 0.5, type: 'arrow' },
                middle: { enabled: false, scaleFactor: 0.5, type: 'arrow' },
                from: { enabled: false, scaleFactor: 0.5, type: 'arrow' }
            },
            arrowStrikethrough: true,
            dashes: false,
            label: link.text,
            color: {
                color: 'grey',
                highlight: 'grey',
                hover: 'grey',
                inherit: 'from',
                opacity: 1.0
            },
            selectionWidth: function (width) { return width; },
            labelHighlightBold: false,
            font: {
                color: '#343434',
                size: 15,
                face: 'arial',
                background: '#ffffff',
                strokeWidth: 2,
                strokeColor: '#ffffff',
                align: 'horizontal',
                multi: false,
                vadjust: 0
            }
        };
    };
    __decorate([
        computedFrom('_selectedNode'),
        __metadata("design:type", NetworkNode),
        __metadata("design:paramtypes", [NetworkNode])
    ], WorkflowConfigurationViewModel.prototype, "selectedNode", null);
    __decorate([
        computedFrom('_entityType'),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [])
    ], WorkflowConfigurationViewModel.prototype, "entityTypeUri", null);
    __decorate([
        computedFrom('_selectedItem'),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [Object])
    ], WorkflowConfigurationViewModel.prototype, "selectedItem", null);
    __decorate([
        computedFrom('_entityType'),
        __metadata("design:type", Number),
        __metadata("design:paramtypes", [Number])
    ], WorkflowConfigurationViewModel.prototype, "entityType", null);
    WorkflowConfigurationViewModel = __decorate([
        autoinject(),
        transient(),
        __metadata("design:paramtypes", [WorkflowConfigurationService,
            NotificationClientService,
            DialogClientService,
            UserClientService,
            EventAggregator,
            BindingEngine])
    ], WorkflowConfigurationViewModel);
    return WorkflowConfigurationViewModel;
}());
export { WorkflowConfigurationViewModel };
